import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { GuiaswebServiceService } from '../../servicios/guiasweb-service.service';
import { environment } from "src/environments/environment";
import { documentacion } from "../../entidades/gwdocumentacion";
import { Router } from "@angular/router";
import { user } from "../../entidades/gwuser";
import { MensajePopup } from "src/app/entidades/MensajePopup";
import jwt_decode from "jwt-decode";
import { HttpErrorResponse } from "@angular/common/http";
import { MensajeService } from "src/app/servicios/mensaje.service";
import  Swal  from 'sweetalert2';

@Component({
  selector: "app-gw-doc-destinatario",
  templateUrl: "./gw-doc-destinatario.component.html",
  styleUrls: ["./gw-doc-destinatario.component.css"],
})
export class GwDocDestinatarioComponent implements OnInit {
  submitted: boolean;
  pais: any;
  ciudad: any;
  estado: any;
  colonia: any;
  idpais: number;
  idciudad: number;
  idestado: number;
  idcolonia: number;
  destinatarioForm: FormGroup;
  doc: documentacion;
  datagw: any;
  tipopaquete: string;
  showModalDirectorioDest: boolean = false;
  searchTermDest: string = '';
  listaDestinatariosFiltrada: any[] = [];
  listaDestinatarios: any[] = [];
  editingIddir: number | null = null;
  userGw: user;

  token: string;
  tokendatos: any;

  constructor(
    private GuiaswebServiceService: GuiaswebServiceService,
    private router: Router,
    private mensajeService: MensajeService
  ) {}

  async ngOnInit(): Promise<void> {
    this.validarsesion();

    this.token = sessionStorage.getItem("token");
    this.tokendatos = jwt_decode(this.token);
    this.userGw = this.tokendatos;

    this.DestinatarioForm();
    this.tipopaquete = decodeURIComponent(
      escape(window.atob(sessionStorage.getItem("gwTipopaq")))
    );
    var docaux = decodeURIComponent(
      escape(window.atob(sessionStorage.getItem("gwDocumentacion")))
    );

    this.doc = JSON.parse(docaux);

    // this.cargarPais();
    await this.cargardatosGuardatos();
    this.cargarDestinatarios();

    document.getElementById("nombred").focus();
    window.scrollTo(0, 0);
  }

  DestinatarioForm() {
    this.destinatarioForm = new FormGroup({
      nombre: new FormControl("", [Validators.required]),
      selectPais: new FormControl("", [Validators.required]),
      selectEstado: new FormControl("", [Validators.required]),
      selectCiudad: new FormControl("", [Validators.required]),
      selectColonia: new FormControl("", [Validators.required]),
      sucursalSeleccionado: new FormControl({ value: false, disabled: true }),
      domicilioSeleccionado: new FormControl({ value: false, disabled: true }),
      direccion: new FormControl("", [Validators.required]),
      telefono: new FormControl("", [
        Validators.required,
        Validators.pattern("[0-9]{10}"),
      ]),
      cp: new FormControl({ value: null, disabled: true }),
      guardarDestinatario: new FormControl(false),
    });
  }

  get Des() {
    return this.destinatarioForm.controls;
  }

  validarsesion() {
    if (
      sessionStorage.getItem("token") == undefined ||
      sessionStorage.getItem("token") == "" ||
      sessionStorage.getItem("token") == null
    ) {
      this.mensajeService.subject$.next(
        new MensajePopup("Su sesión ha expirado", false, false)
      );
      this.router.navigate(["/herramientasDigitales/login"]);
    }

    if (
      sessionStorage.getItem("gwTipopaq") == undefined ||
      sessionStorage.getItem("gwTipopaq") == "" ||
      sessionStorage.getItem("gwTipopaq") == null ||
      sessionStorage.getItem("gwDocumentacion") == undefined ||
      sessionStorage.getItem("gwDocumentacion") == "" ||
      sessionStorage.getItem("gwDocumentacion") == null
    ) {
      this.mensajeService.subject$.next(
        new MensajePopup("Su sesión ha expirado", false, false)
      );
      this.router.navigate(["/herramientasDigitales/documentacion/menu"]);
    }
  }

  //cargamos los datos si regremos de una pantalla más adelante
  async cargardatosGuardatos() {
    if (
      this.doc.destinatario.ciudad != 0 &&
      this.doc.destinatario.estado != 0
    ) {
      this.idpais = 1;
      this.idestado = this.doc.destinatario.estado;
      this.idciudad = this.doc.destinatario.ciudad;
      this.idcolonia = this.doc.destinatario.colonia;
      // this.cargarPais();
      await this.cargarEstado();
      await this.cargarCiudad();

      // Habilitar los campos
      this.destinatarioForm.get("sucursalSeleccionado").enable();
      this.destinatarioForm.get("domicilioSeleccionado").enable();

      const esSucursal = this.doc.destinatario.NombreColonia === "OCURRE" || (this.doc.destinatario.direccion && this.doc.destinatario.direccion.toUpperCase() === 'OCURRE');

      if (esSucursal) {
        // Establecer valores
        this.destinatarioForm.get("sucursalSeleccionado").setValue(true);
        this.destinatarioForm.get("domicilioSeleccionado").setValue(false);
        this.destinatarioForm.controls.direccion.disable();
        this.destinatarioForm.controls.cp.disable();
      } else {
        // Establecer valores
        this.destinatarioForm.get("sucursalSeleccionado").setValue(false);
        this.destinatarioForm.get("domicilioSeleccionado").setValue(true);
        this.destinatarioForm.controls.direccion.enable();
        this.destinatarioForm.controls.cp.enable();
      }

      // Forzar la actualización de la validez
      this.destinatarioForm.get("sucursalSeleccionado").updateValueAndValidity();
      this.destinatarioForm.get("domicilioSeleccionado").updateValueAndValidity();

      await this.cargarColonia();

      this.destinatarioForm.controls.nombre.setValue(this.doc.destinatario.nombre);
      this.destinatarioForm.controls.selectPais.setValue(1);
      this.destinatarioForm.controls.selectEstado.setValue(this.doc.destinatario.estado);
      this.destinatarioForm.controls.selectCiudad.setValue(this.doc.destinatario.ciudad);
      this.destinatarioForm.controls.selectColonia.setValue(this.doc.destinatario.colonia);
      this.destinatarioForm.controls.direccion.setValue(this.doc.destinatario.direccion);
      this.destinatarioForm.controls.telefono.setValue(this.doc.destinatario.tel);
      this.destinatarioForm.controls.cp.setValue(this.doc.destinatario.cp);
    }
     else {
      await this.cargarPais();
    }
  }

  cambiarFocus(e) {
    if (
      !(
        (e.keyCode >= 48 && e.keyCode <= 57) ||
        e.keyCode == 8 ||
        e.keyCode == 9 ||
        e.keyCode == 13 ||
        e.keyCode == 38 ||
        e.keyCode == 40 ||
        e.keyCode == 37 ||
        e.keyCode == 39 ||
        (e.keyCode >= 96 && e.keyCode <= 105)
      )
    ) {
      e.preventDefault();
    }
  }

  async cargarPais() {
    await this.GuiaswebServiceService.obtenerPais(
      "DST",
      this.doc.idsesion,
      this.token
    ).then((d) => {
      this.pais = d;
      this.destinatarioForm.get('selectPais').setValue(this.pais[0].idpais);
        // alert(this.pais[0].pais);
        this.paisChanged('1');
    });
  }

  async cargarEstado() {
    await this.GuiaswebServiceService.obtenerEstado(
      this.idpais,
      "DST",
      this.doc.idsesion,
      this.token
    ).then((d) => {
      this.estado = d;
    });
  }

  async cargarCiudad() {
    await this.GuiaswebServiceService.obtenerCiudades(
      this.idestado,
      "DST",
      this.doc.idsesion,
      this.token
    ).then((d) => {
      this.ciudad = d;
    });
  }

  async cargarColonia() {
    await this.GuiaswebServiceService.obtenerColonias(
      this.idestado,
      this.idciudad,
      "DST",
      this.doc.idsesion,
      this.token
    ).then((d) => {
      this.colonia = d;

      if(this.destinatarioForm.get('sucursalSeleccionado').value == true && this.destinatarioForm.get('domicilioSeleccionado').value == true){
          // alert("Solo uno");
          this.destinatarioForm.get('sucursalSeleccionado').setValue(false);
          this.destinatarioForm.get('domicilioSeleccionado').setValue(false);
          this.colonia = [];
          this.destinatarioForm.controls.selectColonia.setValue("");
         return
      }

      if(this.destinatarioForm.get('sucursalSeleccionado').value == false && this.destinatarioForm.get('domicilioSeleccionado').value == false){
          this.destinatarioForm.get('sucursalSeleccionado').setValue(false);
          this.destinatarioForm.get('domicilioSeleccionado').setValue(false);
          this.colonia = [];
          this.destinatarioForm.controls.selectColonia.setValue("");
         return
      }

      if(this.destinatarioForm.get('sucursalSeleccionado').value == true && this.destinatarioForm.get('domicilioSeleccionado').value == false){
          this.colonia = d;
         // Conservar solo el primer elemento del array
          const optionOcurre = this.colonia[0];
          this.colonia.splice(1); // Eliminar los elementos después del primer elemento
          // Asignar el array modificado al FormControl
          this.destinatarioForm.get("selectColonia").setValue(optionOcurre.idcol);
          this.destinatarioForm.get('selectColonia').setValue(this.colonia.length > 0 ? this.colonia[0].idcol : null);
          // this.remitenteForm.controls.selectColonia.setValue(-1);
          this.destinatarioForm.controls.direccion.setValue(
          this.colonia[0].colonia);
          this.destinatarioForm.controls.cp.setValue("0");
          this.destinatarioForm.controls.cp.disable();
          // this.coloniaChanged(-1);
          this.destinatarioForm.controls.direccion.disable();
       }

       if(this.destinatarioForm.get('sucursalSeleccionado').value == false && this.destinatarioForm.get('domicilioSeleccionado').value == true){
        this.colonia = d;
        if (Object.keys(this.colonia).length > 1) {
            // Eliminar el primer elemento del array
            this.colonia.shift();
            // Asignar el array modificado al FormControl
            this.destinatarioForm.get('selectColonia').setValue(this.colonia.length > 0 ? this.colonia[0].idcol : null);
            this.destinatarioForm.controls.direccion.setValue('');
            return
          } else {
              this.destinatarioForm.get('selectColonia').setValue(this.colonia.length > 0 ? this.colonia[0].idcol : null);
              this.destinatarioForm.controls.direccion.setValue(this.colonia[0].colonia);
              this.destinatarioForm.controls.cp.setValue("0");
              this.destinatarioForm.controls.cp.disable();
              this.destinatarioForm.controls.direccion.disable();
              this.destinatarioForm.get('sucursalSeleccionado').setValue(true);
              this.destinatarioForm.get('domicilioSeleccionado').setValue(false);
              // alert("Actualmente esta ciudad no tiene recolecciones a domicilio");
              Swal.fire({
                icon: 'info',
                title: 'Informativo',
                text: 'No se encontró cobertura a domicilio.',
                customClass: {
                  container: 'norecoleccion-modal'
                }
              });
              return
          }
       }

      // if (this.colonia.length == 1) {
      //   this.destinatarioForm.controls.selectColonia.setValue(-1);
      //   this.coloniaChanged(-1);

      //   this.destinatarioForm.controls.direccion.disable();
      // }
    });
  }

  solicitar() {
    this.submitted = true;
    if (this.destinatarioForm.valid) {
    }
  }

  //creamos la sesion en el paso 3
  async guardarsesion_paso3() {
    this.validarsesion();
    this.submitted = true;
    if (this.destinatarioForm.valid) {
      this.doc.paso = 3;
      this.llenarDestinatario();

      if (this.destinatarioForm.get('guardarDestinatario')?.value === true) {
        const json = {
          opr: this.editingIddir ? "UPD" : "ALT",
          iddir: this.editingIddir ? this.editingIddir : 0,
          nombre: this.destinatarioForm.controls.nombre.value,
          estado: Number(this.destinatarioForm.controls.selectEstado.value),
          ciudad: Number(this.destinatarioForm.controls.selectCiudad.value),
          colonia: Number(this.destinatarioForm.controls.selectColonia.value),
          direccion: this.destinatarioForm.controls.direccion.value,
          tel: this.destinatarioForm.controls.telefono.value,
          cp: this.destinatarioForm.controls.cp.value ? this.destinatarioForm.controls.cp.value.toString() : "",
          idcliente: this.userGw.idUser.toString(),
          tipodir: "D"
        };

        // Comprobación de duplicados en la lista local antes de realizar el alta
        let esDuplicado = false;
        if (!this.editingIddir && this.listaDestinatarios && this.listaDestinatarios.length > 0) {
          const nombreNorm = String(json.nombre).toLowerCase().trim();
          const direccionNorm = String(json.direccion).toLowerCase().trim();
          const telNorm = String(json.tel).toLowerCase().trim();
          
          esDuplicado = this.listaDestinatarios.some((dest: any) => {
            const matchNombre = String(dest.nombre).toLowerCase().trim() === nombreNorm;
            const matchDireccion = String(dest.direccion).toLowerCase().trim() === direccionNorm;
            const matchTel = String(dest.tel).toLowerCase().trim() === telNorm;
            const matchEstado = Number(dest.estado) === json.estado;
            const matchCiudad = Number(dest.ciudad) === json.ciudad;
            const matchColonia = Number(dest.colonia) === json.colonia;
            
            return matchNombre && matchDireccion && matchTel && matchEstado && matchCiudad && matchColonia;
          });
        }

        if (!esDuplicado) {
          try {
            await this.GuiaswebServiceService.wsadmindirecciones(json);
            await this.cargarDestinatarios();
            if (this.editingIddir) {
              Swal.fire({
                icon: 'success',
                title: 'Destinatario actualizado',
                text: 'El destinatario ha sido actualizado con éxito en tu directorio.',
                confirmButtonColor: '#f05a24'
              });
              this.editingIddir = null;
            } else {
              Swal.fire({
                icon: 'success',
                title: 'Destinatario guardado',
                text: 'El destinatario ha sido guardado con éxito en tu directorio.',
                confirmButtonColor: '#f05a24'
              });
            }
          } catch (error) {
            console.error("Error al guardar destinatario:", error);
          }
        } else {
          Swal.fire({
            icon: 'info',
            title: 'Destinatario ya registrado',
            text: 'Este destinatario ya se encuentra guardado en tu lista de destinatarios.',
            confirmButtonColor: '#f05a24'
          });
          console.log("El destinatario ya existe en la lista del directorio. Se omitió la inserción para evitar duplicados.");
        }
      }

      await this.GuiaswebServiceService.GwoprsesionDetV2(this.doc, this.token)
        .then((d) => {
          this.datagw = d;

          // agregamos los datos para el paso 4
          this.doc.idsedet = this.datagw.idsedet;
          this.doc.idsesion = this.datagw.idsesion;
          this.doc.paso = 4;
          this.editingIddir = null;
          sessionStorage.removeItem("gwDocumentacion");
          // sessionStorage.setItem('gwDocumentacion', JSON.stringify(this.doc));
          sessionStorage.setItem(
            "gwDocumentacion",
            window.btoa(unescape(encodeURIComponent(JSON.stringify(this.doc))))
          );
          //pasamos a la pantalla de tipo
          this.GuiaswebServiceService.setplantilla(4);
        })
        .catch((error: HttpErrorResponse) => {
          if (error.error.ExceptionMessage == "invalid_token") {
            this.mensajeService.subject$.next(
              new MensajePopup("Su sesión ha expirado", false, false)
            );
            this.router.navigate(["/herramientasDigitales/login"]);
          } else {
            this.mensajeService.subject$.next(
              new MensajePopup(
                "ocurrio un error inesperado al iniciar sesión en tu cuenta",
                false,
                false
              )
            );
          }
        });
    }
  }

  paisChanged(id) {
    this.idpais = id;
    this.idestado = 0;
    this.idciudad = 0;
    this.idcolonia = 0;
    this.destinatarioForm.controls.selectEstado.setValue("");
    this.destinatarioForm.controls.selectCiudad.setValue("");
    this.destinatarioForm.controls.selectCiudad.setValue("");
    this.destinatarioForm.controls.selectColonia.setValue("");
    this.destinatarioForm.controls.cp.setValue("");
    this.cargarEstado();
  }

  estadoChanged(id) {
    this.idestado = id;
    this.idciudad = 0;
    this.idcolonia = 0;
    this.destinatarioForm.controls.selectCiudad.setValue("");
    this.destinatarioForm.controls.selectCiudad.setValue("");
    this.destinatarioForm.controls.selectColonia.setValue("");
    this.destinatarioForm.controls.cp.setValue("");
    this.cargarCiudad();
  }

  ciudadChanged(id) {
    this.idciudad = id;
    this.idcolonia = 0;
    this.destinatarioForm.controls.selectColonia.setValue("");
    this.destinatarioForm.controls.cp.setValue("");
    // this.remitenteForm.get('sucursalSeleccionado').enable();
    // this.remitenteForm.get('recoleccionSeleccionado').enable();
    // this.remitenteForm.get('sucursalSeleccionado').setValue(true);

    // Habilitar los campos
    this.destinatarioForm.get("sucursalSeleccionado").enable();
    this.destinatarioForm.get("domicilioSeleccionado").enable();

    // Establecer valores
    this.destinatarioForm.get("sucursalSeleccionado").setValue(true);
    this.destinatarioForm.get("domicilioSeleccionado").setValue(false);

    // Forzar la actualización de la validez
    this.destinatarioForm.get("sucursalSeleccionado").updateValueAndValidity();
    this.destinatarioForm.get("domicilioSeleccionado").updateValueAndValidity();
    this.cargarColonia();
  }

  coloniaChanged(id) {
    this.idcolonia = id;

    for (let i = 0; i < this.colonia.length; i++) {
      if (this.idcolonia == this.colonia[i].idcol) {
        if (this.idcolonia == -1) {
          this.destinatarioForm.controls.direccion.setValue(
            this.colonia[i].colonia
          );
          this.destinatarioForm.controls.direccion.disable();
        } else {
          this.destinatarioForm.controls.direccion.enable();
        }

        this.destinatarioForm.controls.cp.setValue(this.colonia[i].codigo);
      }
    }
  }

  limpiar() {
    this.editingIddir = null;
    this.destinatarioForm.controls.nombre.setValue("");
    this.destinatarioForm.controls.selectPais.setValue("");
    this.destinatarioForm.controls.selectEstado.setValue("");
    this.destinatarioForm.controls.selectCiudad.setValue("");
    this.destinatarioForm.controls.selectColonia.setValue("");
    this.destinatarioForm.controls.direccion.setValue("");
    this.destinatarioForm.controls.telefono.setValue("");
    this.destinatarioForm.controls.cp.setValue("");
    if (this.destinatarioForm.controls.guardarDestinatario) {
      this.destinatarioForm.controls.guardarDestinatario.setValue(false);
    }
    window.scrollTo(0, 0);
  }

  llenarDestinatario() {
    this.doc.destinatario.nombre = this.destinatarioForm.controls.nombre.value;
    this.doc.destinatario.estado =
      this.destinatarioForm.controls.selectEstado.value;
    this.doc.destinatario.ciudad =
      this.destinatarioForm.controls.selectCiudad.value;
    this.doc.destinatario.colonia =
      this.destinatarioForm.controls.selectColonia.value;
    this.doc.destinatario.direccion =
      this.destinatarioForm.controls.direccion.value;
    this.doc.destinatario.tel = this.destinatarioForm.controls.telefono.value;
    this.doc.destinatario.cp = this.destinatarioForm.controls.cp.value;

    for (let i = 0; i < this.estado.length; i++) {
      if (
        this.destinatarioForm.controls.selectEstado.value ==
        this.estado[i].idedo
      ) {
        this.doc.destinatario.NombreEstado = this.estado[i].estado;
        break;
      }
    }

    for (let i = 0; i < this.ciudad.length; i++) {
      if (
        this.destinatarioForm.controls.selectCiudad.value == this.ciudad[i].idcd
      ) {
        this.doc.destinatario.Nombreciudad = this.ciudad[i].ciudad;
        break;
      }
    }

    for (let i = 0; i < this.estado.length; i++) {
      if (
        this.destinatarioForm.controls.selectColonia.value ==
        this.colonia[i].idcol
      ) {
        this.doc.destinatario.NombreColonia = this.colonia[i].colonia;
        break;
      }
    }
  }

  regresarMenu() {
    this.GuiaswebServiceService.setplantilla(2);
  }

  imprimirEstadoCheckboxes(controlName: string) {
    console.log('Estado de sucursalSeleccionado:', this.destinatarioForm.get('sucursalSeleccionado').value);
    console.log('Estado de domicilioSeleccionado:', this.destinatarioForm.get('domicilioSeleccionado').value);

    if(controlName == "sucursalSeleccionado"){
      this.destinatarioForm.get('domicilioSeleccionado').setValue(false);
    }

    if(controlName == "domicilioSeleccionado"){
       this.destinatarioForm.get('sucursalSeleccionado').setValue(false);
       this.destinatarioForm.controls.direccion.setValue("");
       this.destinatarioForm.controls.direccion.enable();
    }

     this.cargarColonia();
  }

  abrirModalDirectorioDest() {
    this.showModalDirectorioDest = true;
    this.searchTermDest = '';
    this.listaDestinatariosFiltrada = [...this.listaDestinatarios];
  }

  cerrarModalDirectorioDest() {
    this.showModalDirectorioDest = false;
  }

  filtrarDestinatarios() {
    if (!this.searchTermDest) {
      this.listaDestinatariosFiltrada = [...this.listaDestinatarios];
      return;
    }

    const term = this.searchTermDest.toLowerCase().trim();
    this.listaDestinatariosFiltrada = this.listaDestinatarios.filter(dest => 
      dest.nombre.toLowerCase().includes(term) ||
      dest.direccion.toLowerCase().includes(term) ||
      dest.coloniaNombre.toLowerCase().includes(term) ||
      dest.ciudadNombre.toLowerCase().includes(term) ||
      dest.estadoNombre.toLowerCase().includes(term) ||
      dest.tel.includes(term)
    );
  }

  async seleccionarDestinatario(dest: any) {
    this.destinatarioForm.controls.nombre.setValue(dest.nombre);
    this.destinatarioForm.controls.telefono.setValue(dest.tel);

    this.idpais = 1;
    this.idestado = Number(dest.estado);
    await this.cargarEstado();
    await new Promise(resolve => setTimeout(resolve, 50));
    this.destinatarioForm.controls.selectEstado.setValue(this.idestado);

    this.idciudad = Number(dest.ciudad);
    await this.cargarCiudad();
    await new Promise(resolve => setTimeout(resolve, 50));
    this.destinatarioForm.controls.selectCiudad.setValue(this.idciudad);

    const esSucursal = dest.direccion && dest.direccion.toUpperCase() === 'OCURRE';

    // Habilitar y establecer tipo entrega
    this.destinatarioForm.get("sucursalSeleccionado").enable();
    this.destinatarioForm.get("domicilioSeleccionado").enable();
    this.destinatarioForm.get("sucursalSeleccionado").setValue(esSucursal);
    this.destinatarioForm.get("domicilioSeleccionado").setValue(!esSucursal);

    if (esSucursal) {
      this.destinatarioForm.controls.direccion.disable();
      this.destinatarioForm.controls.cp.disable();
    } else {
      this.destinatarioForm.controls.direccion.enable();
      this.destinatarioForm.controls.cp.enable();
    }

    this.idcolonia = Number(dest.colonia);
    // Cargar colonias manualmente para evitar los side-effects de cargarColonia()
    await this.GuiaswebServiceService.obtenerColonias(
      this.idestado,
      this.idciudad,
      "DST",
      this.doc.idsesion,
      this.token
    ).then((d: any) => {
      this.colonia = d;
      // Para entrega a domicilio, si hay más de una colonia (donde el primero suele ser OCURRE), lo removemos
      if (!esSucursal && this.colonia && this.colonia.length > 1) {
        this.colonia.shift();
      } else if (esSucursal && this.colonia && this.colonia.length > 0) {
        // Si es sucursal, dejamos sólo OCURRE
        const optionOcurre = this.colonia[0];
        this.colonia.splice(1);
      }
    }).catch(err => console.error("Error al cargar colonias", err));

    await new Promise(resolve => setTimeout(resolve, 150));

    let matchedId = null;
    if (this.idcolonia && this.colonia) {
      // 1. Buscar por ID exacto
      let found = this.colonia.find((c: any) => Number(c.idcol) === Number(this.idcolonia));

      // 2. Si no, por Nombre
      if (!found && dest.coloniaNombre) {
        const nombreBuscado = dest.coloniaNombre.toLowerCase().trim();
        found = this.colonia.find((c: any) => c.colonia && c.colonia.toLowerCase().trim().includes(nombreBuscado));
      }

      if (found) {
        matchedId = Number(found.idcol);
        this.destinatarioForm.controls.selectColonia.setValue(matchedId);
        this.destinatarioForm.controls.cp.setValue(found.codigo);
      } else {
        console.warn("No se encontró la colonia en la lista. ID buscado:", this.idcolonia, "Nombre buscado:", dest.coloniaNombre);
        if (esSucursal && this.colonia && this.colonia.length > 0) {
          this.destinatarioForm.controls.selectColonia.setValue(this.colonia[0].idcol);
          this.destinatarioForm.controls.cp.setValue("0");
        } else {
          this.destinatarioForm.controls.cp.setValue(dest.cp);
        }
      }
    } else {
      if (esSucursal && this.colonia && this.colonia.length > 0) {
        this.destinatarioForm.controls.selectColonia.setValue(this.colonia[0].idcol);
        this.destinatarioForm.controls.cp.setValue("0");
      } else {
        this.destinatarioForm.controls.cp.setValue(dest.cp);
      }
    }

    // Establecer la dirección al final para que no sea sobrescrita por ningún evento
    this.destinatarioForm.controls.direccion.setValue(dest.direccion);

    this.cerrarModalDirectorioDest();
  }
  async cargarDestinatarios() {
    const json = {
      opr: "VER",
      iddir: 0,
      nombre: "",
      estado: 0,
      ciudad: 0,
      colonia: 0,
      direccion: "",
      tel: "",
      cp: "",
      idcliente: this.userGw.idUser.toString(),
      tipodir: "D"
    };

    await this.GuiaswebServiceService.wsadmindirecciones(json)
      .then((res: any) => {
        if (res.nummsg == "1") {
          this.listaDestinatarios = JSON.parse(res.outdata);
        } else {
          this.listaDestinatarios = [];
        }
        this.filtrarDestinatarios();
      })
      .catch(err => {
        console.error("Error al cargar destinatarios", err);
        this.listaDestinatarios = [];
        this.filtrarDestinatarios();
      });
  }

  async editarDestinatario(dest: any, event: Event) {
    if (event) {
      event.stopPropagation();
    }
    // Populate form
    await this.seleccionarDestinatario(dest);
    
    // Set edit mode details
    this.editingIddir = dest.iddir;
    if (this.destinatarioForm.controls.guardarDestinatario) {
      this.destinatarioForm.controls.guardarDestinatario.setValue(true);
    }
  }

  cancelarEdicion() {
    this.editingIddir = null;
    this.limpiar();
  }

  async eliminarDestinatario(dest: any, event: Event) {
    if (event) {
      event.stopPropagation();
    }

    Swal.fire({
      title: '¿Estás seguro?',
      text: `¿Deseas eliminar a "${dest.nombre}" de tu directorio?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#F05A28',
      cancelButtonColor: '#6d6e70',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const json = {
          opr: "DEL",
          iddir: dest.iddir,
          nombre: dest.nombre,
          estado: Number(dest.estado),
          ciudad: Number(dest.ciudad),
          colonia: Number(dest.colonia),
          direccion: dest.direccion,
          tel: dest.tel,
          cp: dest.cp ? dest.cp.toString() : "",
          idcliente: this.userGw.idUser.toString(),
          tipodir: "D"
        };

        try {
          await this.GuiaswebServiceService.wsadmindirecciones(json);
          await this.cargarDestinatarios();
          
          Swal.fire({
            title: 'Eliminado',
            text: 'El destinatario ha sido eliminado de tu directorio.',
            icon: 'success',
            confirmButtonColor: '#F05A28'
          });

          if (this.editingIddir === dest.iddir) {
            this.cancelarEdicion();
          }
        } catch (error) {
          console.error("Error al eliminar destinatario:", error);
          Swal.fire({
            title: 'Error',
            text: 'Hubo un error al eliminar el destinatario. Por favor, inténtalo de nuevo.',
            icon: 'error',
            confirmButtonColor: '#F05A28'
          });
        }
      }
    });
  }
  nuevoDestinatario() {
    this.limpiar();
    this.cerrarModalDirectorioDest();
  }

}

